import iziToast, { IziToastSettings } from 'izitoast';
import { APP_TRANSLATE } from 'src/app/app-translate';
import Swal, { SweetAlertOptions } from 'sweetalert2';

const defaultSettings: IziToastSettings = {
  position: 'topRight',
  timeout: 5000,
};

const translate = (key: string, params?: Record<string, any>): string => {
  const res = APP_TRANSLATE?.instant?.(key, params);
  return typeof res === 'string' ? res : key;
};

export function alertSuccess(settings: IziToastSettings = {}) {
  return iziToast.success({
    ...defaultSettings,
    class: 'iziToast-fonts',
    title: translate('SUCCESS'),
    message: ``,
    ...settings,
  });
}
export function alertWarning(settings: IziToastSettings = {}) {
  return iziToast.warning({
    ...defaultSettings,
    class: 'iziToast-fonts',
    title: translate('ALERT'),
    message: ``,
    ...settings,
  });
}
export function alertInfo(settings: IziToastSettings = {}) {
  return iziToast.info({
    ...defaultSettings,
    class: 'iziToast-fonts',
    title: translate('DATA'),
    message: ``,
    ...settings,
  });
}
export function alertDanger(settings: IziToastSettings = {}) {
  return iziToast.error({
    ...defaultSettings,
    class: 'iziToast-fonts',
    title: translate('ERROR'),
    message: ``,
    ...settings,
  });
}

const defaultOptions: SweetAlertOptions = {
  icon: 'warning',
  showCancelButton: true,
  showConfirmButton: true,
  cancelButtonText: translate('CANCEL'),
  confirmButtonText: translate('CONFIRM'),
  reverseButtons: true,
  focusCancel: true,
  confirmButtonColor: 'var(--bs-primary)',
};
export function alertConfirm(options: SweetAlertOptions = {}) {
  return Swal.fire({
    ...defaultOptions,
    title: translate('CONFIRMATION'),
    // html: `คุณต้องการดำเนินการต่อ?`,

    ...Object.assign(
      {},
      {
        ...options,
        html: options.html || options.text || translate('DO_YOU_WANT_TO_CONTINUE'),
      },
    ),
  });
}
export function alertConfirmDanger(options: SweetAlertOptions = {}) {
  return Swal.fire({
    ...defaultOptions,
    title: options.title ?? translate('CONFIRMATION'),
    // html: `คุณต้องการดำเนินการต่อ?`,
    confirmButtonColor: 'var(--bs-danger)',
    iconColor: 'var(--bs-danger)',
    ...Object.assign(
      {},
      {
        ...options,
        html: options.html || options.text || translate('DO_YOU_WANT_TO_CONTINUE'),
      },
    ),
  });
}

const alertTextMap = {
  formInvalid: 'PLEASE_FILL_IN_ALL_REQUIRED_FILEDS',
  saveSuccess: 'ALERT_SAVE_SUCCESS',
  loginSuccess: 'ALERT_LOGIN_SUCCESS',
  confirmDelete: 'DO_YOU_WANT_TO_DELETE_DATA',
  deleteSuccess: 'ALERT_DELETE_SUCCESS',
} as const;

export const alertText: Record<keyof typeof alertTextMap, string> = {
  formInvalid: '',
  saveSuccess: '',
  loginSuccess: '',
  confirmDelete: '',
  deleteSuccess: '',
};

export type AlertTextKey = keyof typeof alertText;

export function setAlertTextTranslations(): typeof alertText {
  Object.assign(alertText, {
    formInvalid: translate(alertTextMap.formInvalid),
    saveSuccess: translate(alertTextMap.saveSuccess),
    loginSuccess: translate(alertTextMap.loginSuccess),
    confirmDelete: translate(alertTextMap.confirmDelete),
    deleteSuccess: translate(alertTextMap.deleteSuccess),
  });

  return alertText;
}

export function getAlertText(key: AlertTextKey): string {
  return alertText[key] || translate(alertTextMap[key]);
}

export function confirmDelete(text: string): string {
  return translate('CONFIRM_DELETE_ITEM', { text });
}
